var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVnrPersonaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95912 4C8.30226 4 6.95912 5.34315 6.95912 7C6.95912 8.65685 8.30226 10 9.95912 10C11.616 10 12.9591 8.65685 12.9591 7C12.9591 5.34315 11.616 4 9.95912 4ZM7.95912 7C7.95912 5.89543 8.85455 5 9.95912 5C11.0637 5 11.9591 5.89543 11.9591 7C11.9591 8.10457 11.0637 9 9.95912 9C8.85455 9 7.95912 8.10457 7.95912 7Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71336 14.1876C7.23294 12.904 8.49106 12 9.95913 12C11.4272 12 12.6853 12.904 13.2049 14.1876C13.3085 14.4436 13.6 14.5671 13.856 14.4635C14.1119 14.3599 14.2355 14.0684 14.1318 13.8124C13.4647 12.1642 11.8484 11 9.95913 11C8.06982 11 6.45361 12.1642 5.78642 13.8124C5.68281 14.0684 5.80631 14.3599 6.06228 14.4635C6.31825 14.5671 6.60974 14.4436 6.71336 14.1876Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVnrPersonaIcon);
export default __webpack_public_path__ + "static/media/vnr-persona-icon.abbea2bc5b11f1deccfe1a3baaa23cf7.svg";
export { ForwardRef as ReactComponent };